module.exports = __webpack_public_path__ + "img/icon_star_rate_active.912ef2de.svg";